<template>
    <svg class="icon-arrow fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.06 13.06"><polygon points="0 7.26 30.21 7.26 25.47 12 26.53 13.06 33.06 6.53 26.53 0 25.47 1.06 30.2 5.79 0 5.79 0 7.26"/></svg>
</template>